import axiosServices from "../utils/axios";

export const addClosuresReports= async (data: { [key: string]: any }) => {
  const response = await axiosServices.post(`/reports/closurereport`, data);
  return (response.data);
};

export const getClosuresReports = async (params: { notification_intro: String; portCalls: string; startDate:string, endDate:string}) => {
  const response = await axiosServices.get(`/reports/closurereport`, {params});
  return response
};